<template>
  <v-snackbar
    v-model="snackbar"
    tile
    multi-line
    color="primary"
    :timeout="10000"
    class="pa-15 font-weight-bold"
  >
    <v-container>
      <v-row
        class=""
        align-content="center"
        align-items="center"
      >
        <v-col
          cols="auto"
          class="align-self-center"
        >
          <ekitabu-icon x-large>
            mdi-alert-outline
          </ekitabu-icon>
        </v-col>
        <v-col>
          <v-container class="">
            <v-row v-if="errorLabel != ''">
              <v-col class="pa-0 text-uppercase">
                {{ errorLabel }}:
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pa-0">
                {{ $te('errors.'+errorMessage) ? $t('errors.'+errorMessage) : errorMessage }}
              </v-col>
            </v-row>
            <v-row v-if="debugMessage">
              <v-col class="pa-0 pt-2">
                <v-btn
                  x-small
                  text
                  color="textOnError"
                  class="px-0"
                  @click="showDebug = !showDebug"
                >
                  <ekitabu-icon
                    x-small
                    left
                  >
                    {{ showDebug ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                  </ekitabu-icon>
                  {{ showDebug ? $t('hideDetails') : $t('showDetails') }}
                </v-btn>
                <div
                  v-if="showDebug"
                  class="debug-message mt-1 pa-2"
                >
                  {{ debugMessage }}
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <template #action="{ attrs }">
      <v-btn
        color="red"
        text
        v-bind="attrs"
        @click="snackbar = false"
      >
        <ekitabu-icon color="white">
          mdi-close-circle
        </ekitabu-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    errorMessage: {
      type: String,
      default: "",
    },
    errorLabel: {
      type: String,
      default: "",
    },
    debugMessage: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      snackbar: this.value,
      showDebug: false,
    };
  },
  watch: {
    value(val) {
      this.snackbar = val;
      if (!val) {
        this.showDebug = false;
      }
    },
    snackbar(val) {
      this.$emit("input", val);
    },
  },
};
</script>

<style scoped>
.debug-message {
  font-family: monospace;
  font-size: 0.75rem;
  font-weight: normal;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  word-break: break-word;
  white-space: pre-wrap;
}
</style>
